<script lang="ts">
    import { draw } from "svelte/transition";
    import { quintOut } from "svelte/easing";
    import { onMount } from "svelte";

    export let useObserver: boolean = true;
    // setup some helper variables to trigger classes
    let go: boolean = false;

    const lines: string[] = [
        "m 67.41492,69.702069 c 1.431225,0.05812 2.759742,-0.298056 4.188595,-0.398876 2.037875,-0.14379 4.112473,0.370766 6.155318,0.390687 2.358418,0.023 4.698315,-0.501518 7.056285,-0.450108 2.376853,0.05182 4.370024,0.545241 6.746345,0.617472 1.996008,0.06067 4.212863,-0.433479 6.20963,-0.458992 2.346067,-0.02998 4.921777,0.413509 7.267027,0.344564 2.47601,-0.07279 4.75477,-0.659618 7.22943,-0.550108 2.43085,0.107566 5.07038,0.804274 7.50049,0.681013 2.44719,-0.124128 4.81003,-0.504884 7.25614,-0.361003",
        "m 67.41492,69.702069 c 1.431225,0.05812 2.865677,0.03671 4.29453,-0.06411 2.037875,-0.14379 4.068321,-0.449066 6.111166,-0.429145 2.358418,0.023 4.695153,0.479272 7.053123,0.530682 2.376853,0.05182 4.749504,-0.308276 7.125825,-0.236045 1.996008,0.06067 3.978126,0.426035 5.974893,0.400522 2.346063,-0.02998 4.657833,-0.598805 7.003083,-0.66775 2.47601,-0.07279 4.93361,0.412408 7.40827,0.521912 2.43085,0.107566 4.86097,-0.147817 7.29108,-0.271078 2.44719,-0.124128 4.90118,-0.114221 7.34729,0.02966",
        "m 67.41492,69.702069 c 1.426153,-0.242315 2.879305,-0.325371 4.32378,-0.24713 2.148717,0.116387 4.273522,0.587768 6.425389,0.586934 2.191985,-8.5e-4 4.35791,-0.49184 6.548954,-0.556043 2.526099,-0.07402 5.041667,0.42012 7.568367,0.370695 1.908855,-0.03734 3.802594,-0.384662 5.711739,-0.401586 2.344251,-0.02078 4.668281,0.456656 7.012321,0.49426 2.46706,0.03958 4.91649,-0.408195 7.38237,-0.49426 2.42038,-0.08448 4.83774,0.17988 7.2576,0.278021 2.46061,0.09979 4.92819,0.02748 7.37874,-0.216239",
    ];

    const drawMe = () => {
        setTimeout(() => {
            go = true; // start the fly animation
        }, 1500);
    };

    onMount(() => {
        if (useObserver === false) drawMe();
    });

    export const watch = (heading: HTMLDivElement) => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    drawMe();
                    observer.unobserve(heading);
                }
            },
            {
                threshold: [0.25],
            }
        );
        observer.observe(heading);
    };
</script>

<div class="wrap" use:watch>
    <h2>
        <slot />
    </h2>
    {#if go}
        <svg
            viewBox="0 0 60.269536 1.2041498"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g transform="translate(-67.004012,-69.111382)">
                <path
                    in:draw={{ duration: 2500, easing: quintOut }}
                    d={lines[Math.floor(Math.random() * lines.length)]}
                />
            </g>
        </svg>
    {/if}
</div>

<style>
.wrap {
  position: relative;
  padding-top: 1rem;
  margin-bottom: 2rem;
}
.wrap h2 {
  font-family: "Open Sans", sans-serif;
  font-size: 2em;
  color: transparent;
  font-weight: bold;
  -webkit-text-stroke-width: 1.5px;
  -webkit-text-stroke-color: var(--title);
  text-shadow: 1.7px 1.7px var(--secondary);
  position: relative;
  margin: 1rem 0 1rem 0;
  z-index: 2;
}
.wrap svg {
  width: 60%;
  height: auto;
  stroke: #e0e0e0;
  stroke-width: 0.25;
  fill: transparent;
  position: absolute;
  z-index: 1;
  bottom: -1rem;
  left: 0%;
}
@media (max-width: 500px) {
  .wrap svg {
    stroke-width: 0.5;
    width: 100%;
    left: 0;
  }
  .wrap h2 {
    font-size: 1.6rem;
    -webkit-text-stroke-width: 1px;
    text-shadow: 1px 1px var(--primary);
    text-align: center;
  }
}
</style>
